import React from 'react'

import { ButtonClean } from '@fourthwall/components'

import * as S from './styled'

export const SelfShippingContent = () => {
  return (
    <>
      <S.Heading>I’m shipping orders myself</S.Heading>
      <S.Content>
        You’ll pack and ship orders, upload tracking numbers, and handle customer support yourself.{' '}
        <ButtonClean
          label="Learn more"
          href="https://help.fourthwall.com/hc/en-us/articles/13331284092187-Fourthwall-fulfillment-service-guide"
          target="_blank"
        />
      </S.Content>
    </>
  )
}
